import * as THREE from 'three';
import {AdvertisingManager} from "@alphabatem/js_sdk/src/managers/advertising_manager.js";

export class AdvertisingHandler extends AdvertisingManager {

	existingBillboard = null;
	advertisementObjects = [];

	scene = null;

	/**
	 * Mesh names we will apply the advertising too
	 */
	advertisingMeshNames = {
		"Board_16-9_Board_0": {x:1,y:1},
		"TV_screen": {x: 1, y: 1},
	};

	reset() {
		this.advertisementObjects = [];
	}

	constructor(modelManager, connectionManager, scene) {
		super(modelManager, connectionManager);
		this.registerAssets()
		this.scene = scene; //Bind to 3JS Scene
	}

	registerAssets() {
		// this.modelManager.addModel("billboard", "/assets/billboard/billboard.glb", null)
	}

	registerAdvertisementObject(object, namedMeshAreas = {}) {
		this.advertisementObjects.push(object);
		this.advertisingMeshNames = {...this.advertisingMeshNames, ...namedMeshAreas};
	}

	handleAdvertTrigger(image, meshNames = this.advertisingMeshNames) {
		for (let i in this.advertisementObjects) {
			this.addBillboardImage(this.advertisementObjects[i], image, meshNames)
		}
	}

	addBillboardImage(object, image, meshNames) {
		// console.log('Setting billboard image: ', image, meshNames);

		const loader = new THREE.TextureLoader();
		loader.load(image, (texture) => {

			// console.log("Texture loaded: ", {
			// 	tex: texture,
			// 	obj: object
			// })

			object.traverse((child) => {
				if (child.type === "Mesh" && meshNames[child.name]) {
					const amt = meshNames[child.name]
					const tx= texture.clone();

					// tx.wrapS = THREE.RepeatWrapping;
					tx.wrapS = THREE.MirroredRepeatWrapping;
					// tx.wrapT = THREE.RepeatWrapping;
					tx.wrapT = THREE.MirroredRepeatWrapping;
					// if (amt.x > 1 || amt.y > 1) {
						tx.repeat.set( amt.x, amt.y );
					// }

					child.visible = true;
					tx.flipY = false;
					tx.needsUpdate = true;

					child.material.emissiveIntensity = 1.1;
					child.material.emissiveMap = tx;
					child.material.emissive = new THREE.Color(0xffffff);

					child.material.map = tx;
					child.material.needsUpdate = true;
				}
			});

			object.visible = true; //Hidden until advert applied
		});
	}


	updateAdvertisingAreas(object, image, areas = []) {
		const loader = new THREE.TextureLoader();
		loader.load(image, function (texture) {

			object.traverse(function (child) {
				if (child instanceof THREE.Mesh && areas.indexOf(child.name) > -1) {
					child.material.map = texture;
					child.material.needsUpdate = true;
				}
			});
		});
	}
}